import $ from "jquery";
import PopUpFrame from "./popupframe";

(function () {
    const startPopUpFrame = function (config) {
        if (config) {
            const eventListenerName = config.requiredCookieCategory;
            const popUpFrame = new PopUpFrame(config);
            document.addEventListener(eventListenerName, () => { popUpFrame.Run(); });
        }
    };
    if (window.self !== window.top) {
        return;
    }
    $(document).ready(() => { startPopUpFrame(window.popUpFrameConfig); });
}());
